/**
 * Sanitizes a string value to be safely inserted into HTML innerHTML.
 * Escapes HTML special characters to prevent XSS attacks.
 *
 * @param value - The value to sanitize (string, number, or null/undefined)
 * @returns The sanitized string, or the original value if it's not a string
 *
 * @example
 * sanitizeHtmlText('<script>alert("XSS")</script>')
 * // Returns: '&lt;script&gt;alert(&quot;XSS&quot;)&lt;/script&gt;'
 *
 * @example
 * sanitizeHtmlText('A & B Company')
 * // Returns: 'A &amp; B Company'
 */
export function sanitizeHtmlText(value: string | number | null | undefined): string | number | null | undefined {
	if (typeof value !== 'string') {
		return value;
	}

	return value
		.replace(/&/g, '&amp;') // Must be first to avoid double-encoding
		.replace(/</g, '&lt;')
		.replace(/>/g, '&gt;')
		.replace(/"/g, '&quot;')
		.replace(/'/g, '&#x27;');
}
